import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import extractDialogProps from 'components/extractDialogProps';
import { useSnackbar } from 'notistack';
import useClient from 'components/Auth/useClient';

export function confirmAsync(client, id, contentId) {
  const message = {
    contentId : contentId,
  }
  return client.post(`api/document/${id}/confirm`, message);
}

export default function ConfirmDialog(props) {
  const [dialogProps] = extractDialogProps(props);

  const {
    id,
    contentId,
    title,
    message,
    name,
    buttonName,
    handleClose,
    handleReload,
  } = props;

  const { enqueueSnackbar } = useSnackbar();

  const client = useClient();
  const handleConfirm = React.useCallback(() => {
    confirmAsync(client, id, contentId)
      .then(() => {
        handleClose();
        enqueueSnackbar(name + 'に成功しました。\n画面右上のメニューより、PDFのダウンロードをお願いします。', { variant: 'success', style: { whiteSpace: 'pre-line' }});
        handleReload();
      })
      .catch(() => {
        enqueueSnackbar( name + 'に失敗しました。時間をおいて再度実行して下さい。', {  variant: 'error' });
      });
  }, [client, id, contentId, handleClose]);

  return (
    <div>
      <Dialog
        {...dialogProps}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            キャンセル
          </Button>
          <Button onClick={handleConfirm} color="primary" autoFocus>
            {buttonName}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}